import { IMAGE_UPLOAD_STATE } from '../../../constants';
import * as types from '../../mutationTypes';

export default {
  [types.IMAGE_UPLOAD](state, imageInfo) {
    const index = state.images.findIndex((image) => image.hashCode === imageInfo.hashCode);

    if (index === -1) {
      // eslint-disable-next-line no-param-reassign
      imageInfo.state = IMAGE_UPLOAD_STATE.STATE_UPLOADED;
      state.images.push(imageInfo);
    } else {
      if (state.images[index].state === IMAGE_UPLOAD_STATE.STATE_ADDED) {
        // eslint-disable-next-line no-param-reassign
        imageInfo.state = IMAGE_UPLOAD_STATE.STATE_UPLOADED_AGAIN;
      } else {
        // eslint-disable-next-line no-param-reassign
        imageInfo.state = IMAGE_UPLOAD_STATE.STATE_UPLOADED;
      }

      state.images.splice(index, 1, imageInfo);
    }
  },

  [types.IMAGE_REMOVE](state, imageFile) {
    const index = state.images.findIndex((image) => image.file.dataURL === imageFile.dataURL);
    if (index !== -1) {
      if (state.images[index].state === IMAGE_UPLOAD_STATE.STATE_UPLOADED_AGAIN) {
        state.images[index].state = IMAGE_UPLOAD_STATE.STATE_ADDED;
      } else {
        state.images[index].state = IMAGE_UPLOAD_STATE.STATE_REMOVED;
      }
    }
  },

  [types.IMAGE_ADD](state, imageInfo) {
    const index = state.images.findIndex((image) => image.hashCode === imageInfo.hashCode);
    if (index !== -1) {
      state.images[index].state = IMAGE_UPLOAD_STATE.STATE_ADDED;
    }
  },

  [types.IMAGE_DELETE_ALL](state) {
    state.images = [];
  }
};
